import { useHotkeys } from 'react-hotkeys-hook';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useGlobalKeyboard = () => {
  const navigate = useNavigate();

  // Global search shortcut
  useHotkeys('cmd+k, ctrl+k', (e) => {
    e.preventDefault();
    // TODO: Open global search modal
    console.log('Open search');
  });

  // Navigation shortcuts
  useHotkeys('g i', () => navigate('/ingest'), { preventDefault: true });
  useHotkeys('g v', () => navigate('/verify'), { preventDefault: true });
  useHotkeys('g r', () => navigate('/results'), { preventDefault: true });
  useHotkeys('g p', () => navigate('/photos'), { preventDefault: true });
  useHotkeys('g l', () => navigate('/label'), { preventDefault: true });

  // Save shortcut
  useHotkeys('cmd+s, ctrl+s', (e) => {
    e.preventDefault();
    // Trigger save action if applicable
    window.dispatchEvent(new CustomEvent('keyboard:save'));
  });

  // Export shortcut
  useHotkeys('cmd+e, ctrl+e', (e) => {
    e.preventDefault();
    // Trigger export action if applicable
    window.dispatchEvent(new CustomEvent('keyboard:export'));
  });
};

// Table-specific keyboard navigation
export const useTableKeyboard = (
  onCellEdit: (rowIndex: number, columnId: string) => void,
  onCellNavigate: (direction: 'up' | 'down' | 'left' | 'right') => void,
  enabled = true
) => {
  useHotkeys(
    'enter',
    () => {
      // Enter edit mode for current cell
      window.dispatchEvent(new CustomEvent('table:enter-edit'));
    },
    { enabled }
  );

  useHotkeys(
    'escape',
    () => {
      // Exit edit mode
      window.dispatchEvent(new CustomEvent('table:exit-edit'));
    },
    { enabled }
  );

  useHotkeys('tab', () => onCellNavigate('right'), { enabled, preventDefault: true });
  useHotkeys('shift+tab', () => onCellNavigate('left'), { enabled, preventDefault: true });
  useHotkeys('up', () => onCellNavigate('up'), { enabled, preventDefault: true });
  useHotkeys('down', () => onCellNavigate('down'), { enabled, preventDefault: true });
  useHotkeys('left', () => onCellNavigate('left'), { enabled, preventDefault: true });
  useHotkeys('right', () => onCellNavigate('right'), { enabled, preventDefault: true });
};

// Custom hook for keyboard shortcuts display
export const useKeyboardShortcuts = () => {
  const shortcuts = [
    { keys: ['⌘', 'K'], description: 'Global search' },
    { keys: ['G', 'I'], description: 'Go to Ingest' },
    { keys: ['G', 'V'], description: 'Go to Verify' },
    { keys: ['G', 'R'], description: 'Go to Results' },
    { keys: ['G', 'P'], description: 'Go to Photos' },
    { keys: ['⌘', 'S'], description: 'Save changes' },
    { keys: ['⌘', 'E'], description: 'Export data' },
    { keys: ['↵'], description: 'Edit cell' },
    { keys: ['Esc'], description: 'Cancel edit' },
    { keys: ['Tab'], description: 'Next cell' },
    { keys: ['↑', '↓', '←', '→'], description: 'Navigate cells' },
  ];

  return shortcuts;
};